import { Icon, Loader, Typography } from "@saviynt/design-system";
import { useIntl } from "react-intl";

interface LoadErrorWrapperProps {
  isLoading: boolean;
  isError: boolean;
  className?: string;
}

function LoadErrorWrapper({
  isLoading,
  isError,
  className,
}: LoadErrorWrapperProps) {
  const intl = useIntl();

  return (
    <div
      className={`grid p-4 items-center justify-center h-full ${className ?? ""}`}
      data-testid="load-error-wrapper"
    >
      {isLoading && <Loader kind="dots" format="inline" color="brand" />}
      {isError && (
        <>
          <Icon
            kind="StopProcess"
            size="large"
            color="--color-foreground-critical-medium"
          />
          <Typography className="Nhi-Error-Card-Content-Text">
            {intl.formatMessage({
              id: "tNosvf",
              defaultMessage: "Data couldn't be retrieved.",
              description: "Error message when data cannot be retrieved",
            })}
          </Typography>
        </>
      )}
    </div>
  );
}

export default LoadErrorWrapper;
